export default "__VITE_ASSET__DeE3kk1I__"